import axios from "axios";
import {
  NOTIFICATION_REQUEST,
  NOTIFICATION_SUCCESS,
  NOTIFICATION_FAIL,
} from "../../reduser/Notification/notification";

export const notifications =
  (receiver, sender, message, type) => async (dispatch) => {
    try {
      dispatch({ type: NOTIFICATION_REQUEST.toString() });
      const { data } = await axios.post(
        `v2/notifications/trigger`,
        {
          eventKey: "MISC.GENERIC_INFO",
          payload: {
            receiverId: receiver,
            body: message,
            title: type || "Notification",
          },
          options: {
            channels: ["IN_APP"],
            metadata: {
              sender,
              type,
            },
          },
        },
        { withCredentials: true }
      );

      dispatch({
        type: NOTIFICATION_SUCCESS.toString(),
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: NOTIFICATION_FAIL.toString(),
        payload: error?.response?.data?.message || error?.message,
      });
    }
  };
